export default __webpack_public_path__ + "static/media/notetaker.7704f29b.png";